import React from 'react'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'
import StyledButton from './inputs/StyledButton'
import Checkbox from './inputs/Checkbox'
import AuthHeader from './AuthHeader'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import {
  is_logged_on,
  extract_errors,
  emailComp,
  passComp
 } from "../helpers"

import {
  LocalForm,
  Control,
} from 'react-redux-form'

import Errors from './Errors'

import {
  validateEmailType,
  isRequired
} from "../validators"

import { loginUser } from '../actions'

const font = "'Noto Sans', sans-serif";

const theme  = createMuiTheme({
    typography: {
    fontFamily: font
  }
});

const mapDispatchToProps = dispatch => {
  return {
    loginUser: values => dispatch(loginUser(values)),
  };
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    errors: state.auth.current_user.errors
  };
}


class ConnectedLogin extends React.Component {
  constructor() {
    super()
    this.state = {
      emailValid: true,
      emailError: '',
      passwordValid: true,
      passwordError: '',
      formValid: false
    }
  }

  handleSubmit(values) {
    this.props.loginUser(values)
  }

  handleUpdate(form) {
    const { email, password, $form } = form

    const emailState = (email.pristine || email.valid)
    const passwordState = (password.pristine || password.valid)
    const formState = $form.valid

    this.setState({
      emailValid: emailState,
      passwordValid: passwordState,
      formValid: formState
    })
  }

  componentDidUpdate(prevProps, prevState){
    const { errors } = this.props
    const prevErrors = prevProps.errors

    const emailErrors = extract_errors(errors, "email")
    const prevEmailErrors = extract_errors(prevErrors, "email")

    if (emailErrors && !prevEmailErrors) {
      this.setState({
        emailValid: false,
        emailError: emailErrors
      })
    }

    const passwordErrors = extract_errors(errors, "password")
    const prevPasswordErrors = extract_errors(prevErrors, "password")

    if (passwordErrors && !prevPasswordErrors) {
      this.setState({
        passwordValid: false,
        passwordError: passwordErrors
      })
    }

  }

  render() {
    // const {email, password, $form} = this.props.form
    if ( is_logged_on() ) {
      const { location } = this.props
      const { pathname } = location
      if (pathname !== "/") {
        return <Redirect to="/" />
      }
    }

    return (
      <MuiThemeProvider theme={theme}>
      <section className="header">

        <AuthHeader />

        <div className="inner bottom-gap">
          <Grid container justify="center" spacing= {0}>
            <Grid item xs={12} md={4}>
              <Paper className="no-boxshadow">
              <LocalForm
                model="login"
                className="collection-item ls-015"
                initialState={{ email: '', password: '', remember: false}}
                onUpdate={(form) => this.handleUpdate(form)}
                onSubmit = {(values) => this.handleSubmit(values)}
              >

                <div className="input-ls-015 mb-36">
                  <Control
                    id="login-email"
                    model="login.email"
                    component={emailComp}
                    error={!this.state.emailValid}
                    helperText={this.state.emailValid ? '' : this.state.emailError || "Not a valid Email" }
                    validators={{
                      required: (val) => {
                        return isRequired(val)
                      },
                      validateEmailType: (val) => validateEmailType(val)
                    }}
                  />
                </div>

                <div className="input-ls-015 mb-36">
                  <Control
                    id="login-password"
                    model="login.password"
                    label="Password"
                    component={passComp}
                    error={!this.state.passwordValid}
                    helperText={this.state.passwordValid ? '' : this.state.passwordError || "You must provide a password" }
                    validators={{
                      required: (val) => {
                        return isRequired(val)
                      },
                    }}
                  />
                </div>

                {

                  <Errors errors={this.props.errors} ignore={["email","password"]}/>
                }

                <StyledButton
                  size="small"
                  type="submit"
                  aria-label="Sumbit"
                  disabled={!this.state.formValid}
                  variant="contained"
                  className="mdc-instalevel-w-100 ls-125"
                >SIGN IN</StyledButton>

                <div className="d-inline-block checkbox-wrapper">
                  <Control.checkbox
                    id="login-remember-me"
                    model="login.remember"
                    className="mdc-instalevel-w-100 ls-050"
                    label="Remember Me"
                    color="default"
                    component={Checkbox}
                  />
                </div>

                <div className="forgot-password-login">
                  <Link to="/reset_password" className="link no-t-transform no-t-decoration c-blue ff-noto ls-050">Forgot password?</Link>
                </div>

              </LocalForm>
              </Paper>
            </Grid>
          </Grid>
        </div>
      </section>
      </MuiThemeProvider>
    )
  }
}

const Login = connect(mapStateToProps, mapDispatchToProps)(ConnectedLogin);

export default Login



// WEBPACK FOOTER //
// ./src/js/components/Login.js